import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-phone-inprocess-script-redirection.component.ajs';

@Directive({
  selector: 'cng-agent-booking-phone-inprocess-script-redirection-upgrade',
})
export class AgentBookingPhoneInprocessScriptRedirectionUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-phone-inprocess-script-redirection',
  template:
    '<cng-agent-booking-phone-inprocess-script-redirection-upgrade [responseId]="responseId$ | async"></cng-agent-booking-phone-inprocess-script-redirection-upgrade>',
})
export class AgentBookingPhoneInprocessScriptRedirectionComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
